import { loadStripe } from "@stripe/stripe-js";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { CreditCardIcon } from "lucide-react";
import { useCreatePetiteAnnonceStripeSession } from "../../lib/hooks/usePetitesAnnonces";

interface Props {
  id: string;
}

export default function PayerPetiteAnnonceButton({ id }: Props) {
  const mutation = useCreatePetiteAnnonceStripeSession();

  const handlePay = () => {
    mutation.mutate(id, {
      onSuccess: async (sessionId) => {
        const stripe = await loadStripe(`${import.meta.env.VITE_STRIPE_KEY}`);
        await stripe?.redirectToCheckout({ sessionId });
      },
      onError: (error: any) => {
        console.error(error);
        toast.error(error.response?.data?.message || "Une erreur est survenue lors du paiement");
      },
    });
  };

  return (
    <Button
      icon={<CreditCardIcon size={16} />}
      variant="default"
      className="bg-[#173f35] hover:bg-[#23594a]"
      onClick={handlePay}
      loading={mutation.isPending}
      disabled={mutation.isPending}
    >
      Payer
    </Button>
  );
}
